import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import IconBoxContainer from "../containers/global/icon-box";
import NewsletterArea from "../containers/global/newsletter";
import IntroContainer from "../containers/home/intro";
import ServiceListContainer from "../containers/service/service-list";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";

const HomePage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="adbaja – Services et conseil informatiques" />
                <div className="wrapper">
                    <Header />
                    <IntroContainer />
                    <IconBoxContainer classOption="section-pb" />
                    <ServiceListContainer />
                    <NewsletterArea />
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default HomePage;
